/**
 * This component is used to display a email logs of daily, weekly and principal
 */
import React from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import * as adminActions from "../../../store/admin";
import * as connectionsActions from "../../../store/portal";
import * as userActions from "../../../common/user";
import { bindActionCreators } from "redux";
import BootstrapTable from "react-bootstrap-table-next";
import * as moment from "moment";
import { ExportXlsxCsv } from "./export-xlsx-csv";
import { ExportPdf } from "./export-pdf";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GridLoader } from "react-spinners";
import paginationFactory from "react-bootstrap-table2-paginator";
import { css } from "@emotion/core";
import { BackStrip, Header } from "../../../common/layout";
import { deviceDetect } from "react-device-detect";
import { utilService } from "../../../common/utils";
import { config } from "../../../config/config";

const override = css`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

class ReadPosts extends React.Component {
    constructor(props) {
        super(props);
        this.onTypesChange = this.onTypesChange.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.onReset = this.onReset.bind(this);
        this.onFilter = this.onFilter.bind(this);
        this.eamil_type_name = "PRINCIPAL";
        this.state = {
            filterData: {
                types: "NOTICE",
                start_date: null,
                end_date: null,
                postUid: "",
                username: "",
            },
            errors: {},
            sheetData: [],
            isLoading: false,
            isReseting: false,
            isFitering: false,
        };
    }

    componentDidMount() {
        //save page visit logs to dynamodb
        let device = deviceDetect();
        let osName = utilService.getOsName(device);
        let browserName = utilService.getBrowserName(device);
        let pageLogsData = {
            ipstack_access_key: config.ipstack_access_key,
            pageId: "read-posts",
            title: "Read Posts",
            browserName: browserName,
            osName: osName,
            pageType: "Read Posts Page",
            visited_at: new Date(),
            country_name: this.props.user.country_name,
            users_userid: this.props.user.userUid,
            users_username: this.props.user.username,
            users_firstname: this.props.user.firstname,
            users_lastname: this.props.user.surname,
        };
        // save page logs
        this.props.savePageVisitLogs({
            token: this.props.token,
            data: pageLogsData,
        });

    }

    componentDidUpdate(prevProps, prevState) {

        // New logic: Check if user_filter has been updated after calling getUserData
        if (
            prevState.waitingForUserFilter &&
            this.props.user_filter !== prevProps.user_filter &&
            this.props.user_filter &&
            this.props.user_filter.userUid
        ) {
            this.setState({ waitingForUserFilter: false }); // Reset the flag
            this.callReadPosts();
        }

        if (prevState.isReseting) {
            this.setState({
                isLoading: false,
                isReseting: false,
            });
        }

        if (prevState.isFitering) {
            this.setState({
                isLoading: false,
                isFitering: false,
            });
        }


    }

    onInputChange(e) {
        const { name, value } = e.target;
        let fields = this.state.filterData;
        fields[name] = value;
        this.setState({
            fields,
        });
    }

    onTypesChange(e) {
        let fields = this.state.filterData;
        if (e.target.checked) {
            fields["types"] = e.target.value;
            this.setState({
                fields,
            });
        }
    }

    handleDateChange(date, name) {
        let fields = this.state.filterData;
        fields[name] = date;
        this.setState({
            fields,
        });
    }

    validateForm() {
        let fields = this.state.filterData;
        let errors = {};
        let formIsValid = true;

        //console.log(fields);
        if (fields["start_date"] && fields["end_date"] == null) {
            formIsValid = false;
            errors["end_date"] = "*Please select end date.";
        }

        if (fields["end_date"] && fields["start_date"] == null) {
            formIsValid = false;
            errors["start_date"] = "*Please select start date.";
        }

        if (fields["end_date"] < fields["start_date"]) {
            formIsValid = false;
            errors["end_date"] = "*Please select valid date.";
        }

        if (fields["username"] == "") {
            formIsValid = false;
            errors["username"] = "*Please enter username to filter.";
        }

        if (fields["postUid"] && fields["username"] == "") {
            formIsValid = false;
            errors["username"] = "*Please enter username to filter by postUid.";
        }

        this.setState({
            errors: errors,
        });

        return formIsValid;
    }

    onFilter(e) {
        e.preventDefault();
        this.setState({
            isLoading: true,
            isFitering: true,
            isReseting: false,
        })
        if (this.validateForm()) {
            let fields = this.state.filterData;

            if (fields["username"]) {
                // Set the flag to true before calling getUserData
                this.setState({ waitingForUserFilter: true, isLoading: true, isFitering: true });
                this.props.getUserData({
                    token: this.props.token,
                    username: fields["username"], // Use the username from filterData
                });
            } else {
                // If there's no username to filter by, just call getReadPosts directly
                this.callReadPosts();
            }

        }
    }

    callReadPosts() {
        let fields = this.state.filterData;
        let params = "?";
        let userUid = "";

        if (fields["start_date"]) {
            if (params !== "?") {
                params = params + "&";
            }
            params =
                params +
                `start_date=${moment(fields["start_date"]).format("YYYY-MM-DD")}`;
        }
        if (fields["end_date"]) {
            if (params !== "?") {
                params = params + "&";
            }
            params =
                params +
                `end_date=${moment(fields["end_date"]).format("YYYY-MM-DD")}`;
        }

        if (fields["types"]) {
            if (params !== "?") {
                params = params + "&";
            }
            params = params + `type=${fields["types"].toLowerCase()}`;
        }
        if (fields["username"]) {
            userUid = this.props.user_filter.userUid || userUid; // Use userUid from user_filter if available
        }
        if (fields["postUid"]) {
            if (params !== "?") {
                params = params + "&";
            }
            params = params + `postUid=${fields["postUid"]}`;
        }
        if (params === "?") {
            params = "";
        }
        // console.log(params)
        this.setState({
            isLoading: true,
            isFitering: true,
            isReseting: false,
        });
        this.props.getReadPosts({
            token: this.props.token,
            id: userUid,
            params
        });
    }

    onReset(e) {
        e.preventDefault();
        this.setState({
            filterData: {
                types: "NOTICE",
            },
            isLoading: false,
            isFitering: false,
            isReseting: false,
            errors: {},
        });
        this.myFormRef.reset();
    }

    render() {
        let { readPostsData } = this.props;

        readPostsData = Object.values(readPostsData)
        let columns = [];
        columns.push(
            {
                dataField: "users_userUid",
                text: "Username",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "200px", textAlign: "left" };
                },
                formatter: (cell, row) => {
                    if (this.props.user_filter && this.props.user_filter.userUid) {
                        return this.props.user_filter.username;
                    }
                }
            },
            {
                dataField: "type",
                text: "Type",
                sort: true,
            },
            {
                dataField: "Subject Link",
                text: "Subject Link",
                formatter: (cell, row) => {
                    if (row && row['posts_postUid']) {
                        const posts = this.props.posts;
                        const uuidStr = row['posts_postUid']
                        let subjectStr = uuidStr;

                        if (Object.keys(posts).includes(uuidStr)) {
                            subjectStr = posts[uuidStr].title ?? "";
                        }

                        return (
                            <a className={`postTable-subject-link`} href={`https://places.plc.sydney/notices/notice_details/${row['posts_postUid']}`} target="_blank">
                                {subjectStr}
                            </a>
                        );
                    } else {
                        return "";
                    }
                },
            },
            {
                dataField: "created_at",
                text: "Opened",
                formatter: eventTypeOpenedDateFormatter,
                sort: true,
            },
        );

        const defaultSorted = [
            {
                dataField: "created_at",
                order: "desc",
            },
        ];

        const emailLogsList = readPostsData && (
            <div className="postsTable">
                <BootstrapTable
                    bootstrap4
                    keyField="created_at"
                    wrapperClasses="table-responsive"
                    data={readPostsData}
                    loading={true}
                    columns={columns}
                    defaultSorted={defaultSorted}
                    pagination={paginationFactory()}
                    noDataIndication={indication}
                />
            </div>
        );

        return (
            <div>
                <div className="head-wrap d-flex align-items-center justify-content-between flex-column flex-md-row">
                    <h1>Read Posts</h1>
                </div>
                <div className="filters mb-2">
                    <form ref={(el) => (this.myFormRef = el)}>
                        <h2>Filters</h2>
                        <div className="brd-1">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="date d-flex align-items-center pb-2">
                                        <div className="date">
                                            <p className="datetext">Date From</p>
                                            <DatePicker
                                                className="form-control"
                                                dateFormat="MMMM d, yyyy"
                                                selected={this.state.filterData.start_date}
                                                onChange={(date) =>
                                                    this.handleDateChange(date, "start_date")
                                                }
                                            />
                                            <div className="errorMsg">
                                                {this.state.errors["start_date"]}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="date d-flex align-items-center pb-2">
                                        <div className="date">
                                            <p className="datetext">Date To</p>
                                            <DatePicker
                                                className="form-control"
                                                dateFormat="MMMM d, yyyy"
                                                minDate={this.state.filterData.start_date}
                                                selected={this.state.filterData.end_date}
                                                onChange={(date) =>
                                                    this.handleDateChange(date, "end_date")
                                                }
                                            />
                                            <div className="errorMsg">
                                                {this.state.errors["end_date"]}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brd-1">
                            <h3>Types</h3>
                            <div className="row">
                                <div className="col-md-3">
                                    <label className="typeradio">
                                        NEWSLETTER
                                        <input
                                            type="radio"
                                            name="NEWSLETTER"
                                            checked={this.state.filterData.types === "NEWSLETTER"}
                                            onChange={this.onTypesChange}
                                            value="NEWSLETTER"
                                        />
                                        <span className="radiomark"></span>
                                    </label>
                                </div>
                                <div className="col-md-3">
                                    <label className="typeradio">
                                        NOTICE
                                        <input
                                            type="radio"
                                            name="NOTICE"
                                            checked={this.state.filterData.types === "NOTICE"}
                                            onChange={this.onTypesChange}
                                            value="NOTICE"
                                        />
                                        <span className="radiomark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="brd-1">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="date pb-2">
                                        <p className="datetext">postUid</p>
                                        <input
                                            name="postUid"
                                            type="text"
                                            onChange={this.onInputChange}
                                            value={this.state.filterData.postUid || ""}
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="date pb-2">
                                        <p className="datetext">Username</p>
                                        <input
                                            name="username"
                                            type="text"
                                            onChange={this.onInputChange}
                                            value={this.state.filterData.username || ""}
                                            className="form-control"
                                        />
                                        <div className="errorMsg">
                                            {this.state.errors["username"]}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end pt-1 flex-column flex-lg-row">
                            <div className="">
                                {this.state.isReseting && this.state.isLoading && (
                                    <button
                                        disabled={this.state.isLoading}
                                        onClick={this.onReset}
                                        className="btn-secondary filter-btn"
                                    >
                                        Reset ...
                                    </button>
                                )}
                                {!this.state.isReseting && (
                                    <button
                                        onClick={this.onReset}
                                        className="btn-secondary filter-btn"
                                    >
                                        Reset
                                    </button>
                                )}
                                {this.state.isLoading && this.state.isFitering && (
                                    <button
                                        disabled={this.state.isLoading}
                                        onClick={this.onFilter}
                                        className="btn-secondary filter-btn"
                                    >
                                        Filter ...
                                    </button>
                                )}
                                {!this.state.isFitering && (
                                    <button
                                        onClick={this.onFilter}
                                        className="btn-secondary filter-btn"
                                    >
                                        Filter
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </div>
                <div className="email-hr-line"></div>
                <hr></hr>
                {this.props.isLoading === true && (
                    <div className="sweet-loading">
                        <GridLoader
                            css={override}
                            sizeUnit={"px"}
                            size={40}
                            color={"#cadb2a"}
                            loading={this.props.isLoading}
                        />
                    </div>
                )}
                {emailLogsList}
                <hr></hr>
            </div>
        );
    }
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state) {
    //console.log("State ==========", state.user.user_data);

    return {
        connectionsActionLoading: state.connections.actionsloading,
        token: state.user.cognito_data.token,
        readPostsData: state.connections.readPosts.byId,
        user: state.user.user,
        user_filter: state.user.user_data,
        posts: state.posts.byId
    };
}


function eventTypeOpenedDateFormatter(cell, row, field) {
    if (row) {
        return moment(row["created_at"]).format("YYYY-MM-DD hh:mm a");
    } else {
        return "";
    }
}

function indication() {
    return "No records found!";
}

/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>

    bindActionCreators(Object.assign({}, connectionsActions, userActions, adminActions), dispatch)

)(ReadPosts);
